import { EVENT_PAGE_SLUGS } from './constants';

const getCurrentEventSlug = (path: string) =>
  EVENT_PAGE_SLUGS.find((slug) => path.startsWith(`/${slug}`)) ?? null;

export default getCurrentEventSlug;
